/* Booksy kívánságlista — localStorage-alapú, bejelentkezés és PII nélkül.
   Tárol: [{handle, isbn, title, added}]. NINCS kimenő adat, NINCS kupon/kedvezmény.
   A /wishlist oldal a Storefront /products/{handle}.js-ből tölt friss adatot (r.ok-check). */
(function () {
  'use strict';
  var KEY = 'booksy_wishlist_v1';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      if (!raw) return [];
      var arr = JSON.parse(raw);
      return Array.isArray(arr) ? arr : [];
    } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
  }
  function has(handle) {
    return read().some(function (it) { return it.handle === handle; });
  }
  function toggle(data) {
    var arr = read();
    var idx = -1;
    for (var i = 0; i < arr.length; i++) { if (arr[i].handle === data.handle) { idx = i; break; } }
    if (idx >= 0) { arr.splice(idx, 1); }
    else { arr.unshift({ handle: data.handle, isbn: data.isbn || '', title: data.title || '', added: Date.now() }); }
    write(arr);
    return idx < 0; // true ha most ADTUK hozzá
  }
  function remove(handle) {
    write(read().filter(function (it) { return it.handle !== handle; }));
  }
  function count() { return read().length; }

  function refreshHearts(root) {
    var scope = root || document;
    var btns = scope.querySelectorAll('[data-wishlist-heart]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      var on = has(btn.getAttribute('data-wl-handle'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
      var lbl = on ? 'Eltávolítom a kívánságlistáról' : 'Kívánságlistához adom';
      btn.setAttribute('aria-label', lbl);
      btn.setAttribute('title', lbl);
      var labelEl = btn.querySelector('[data-wishlist-heart-label]');
      if (labelEl) { labelEl.textContent = on ? 'Listámon ✓' : 'Kívánságlistához'; }
    }
  }
  function refreshCount() {
    var n = count();
    var els = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < els.length; i++) {
      els[i].textContent = String(n);
      els[i].hidden = (n === 0);
    }
  }

  // Esemény-delegálás: minden [data-wishlist-heart] kattintás (PDP, kártya, /wishlist ✕)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-heart]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle({
      handle: btn.getAttribute('data-wl-handle'),
      isbn: btn.getAttribute('data-wl-isbn'),
      title: btn.getAttribute('data-wl-title')
    });
    refreshHearts();
    refreshCount();
    if (document.querySelector('[data-wishlist-list]')) { renderList(); }
  });

  // ---- /wishlist oldal ----
  // J05 (L164, 10-21): a termékoldali jelvénnyel azonos felirat; a TÉNYLEGES elérhetőség (p.available) is dönt,
  // nem csak a source:out_of_stock címke (DENY+0 készletű beszállítói termék is lehet nem kapható).
  function badgeFromTags(tags, available) {
    tags = tags || [];
    var source = '', delivery = '';
    for (var i = 0; i < tags.length; i++) {
      var t = tags[i];
      if (t.indexOf('source:') === 0) source = t.slice(7);
      if (t.indexOf('delivery:') === 0) delivery = t.slice(9);
    }
    if (source === 'physical') return { cls: 'instock', label: '✓ Raktáron', sub: '1–3 munkanap' };
    if (source === 'out_of_stock' || available === false) return { cls: 'oos', label: '⊘ Jelenleg nem kapható', sub: 'értesítést kérhetsz' };
    return { cls: 'supplier', label: '📦 Beszállítótól', sub: (delivery || '4-7 munkanap').replace('-', '–') };
  }
  function imgWidth(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fmtPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' lei';
  }

  function renderList() {
    var host = document.querySelector('[data-wishlist-list]');
    if (!host) return;
    var items = read();
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!items.length) {
      host.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    host.setAttribute('aria-busy', 'true');
    Promise.all(items.map(function (it) {
      return fetch('/products/' + encodeURIComponent(it.handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (p) { return { it: it, p: p }; });
    })).then(function (rows) {
      host.innerHTML = rows.map(function (row) {
        var it = row.it, p = row.p;
        if (!p) {
          return '<div class="wishlist-card wishlist-card--gone">' +
            '<div class="wishlist-card__body">' +
            '<p class="wishlist-card__title">' + esc(it.title || it.handle) + '</p>' +
            '<p class="wishlist-card__gone">Jelenleg nem elérhető.</p>' +
            '<button type="button" class="wishlist-card__remove-txt" data-wishlist-heart data-wl-handle="' + esc(it.handle) + '">Eltávolítom</button>' +
            '</div></div>';
        }
        var b = badgeFromTags(p.tags, p.available);
        var kaphato = (p.variants || []).filter(function (v) { return v.available; })[0];
        var img = imgWidth(p.featured_image, 200);
        return '<div class="wishlist-card">' +
          '<a class="wishlist-card__link" href="/products/' + esc(p.handle) + '">' +
          (img ? '<img class="wishlist-card__img" src="' + esc(img) + '" alt="" loading="lazy" width="80">' : '') +
          '<span class="wishlist-card__body">' +
          '<span class="wishlist-card__title">' + esc(p.title) + '</span>' +
          '<span class="wishlist-card__price">' + fmtPrice(p.price) + '</span>' +
          '<span class="wishlist-badge wishlist-badge--' + b.cls + '">' + esc(b.label) + ' · ' + esc(b.sub) + '</span>' +
          '</span></a>' +
          (kaphato ? '<button type="button" class="wishlist-card__add" data-wl-add data-wl-variant="' + esc(kaphato.id) + '" aria-label="' + esc(p.title) + ' – kosárba">Kosárba</button>' : '') +
          '<button type="button" class="wishlist-card__remove" data-wishlist-heart data-wl-handle="' + esc(p.handle) + '" aria-label="Eltávolítom a kívánságlistáról" title="Eltávolítom">✕</button>' +
          '</div>';
      }).join('');
      host.setAttribute('aria-busy', 'false');
    });
  }

  // J05 (L164): Kosárba a listáról — ugyanaz a minta, mint a booksy-quick-add.js-ben: r.ok-ellenőrzés, majd
  // ajaxProduct:added (erre épül újra a kosárfiók és a kosár-jelzés). Hibánál a gomb szöveggel jelez, nem némán.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wl-add]') : null;
    if (!btn || btn.disabled) return;
    var id = parseInt(btn.getAttribute('data-wl-variant'), 10);
    if (!id) return;
    btn.disabled = true; btn.textContent = '…';
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function () { btn.textContent = '✓ Kosárban'; document.dispatchEvent(new CustomEvent('ajaxProduct:added')); })
      .catch(function () { btn.disabled = false; btn.textContent = 'Újra'; });
  });

  function init() { refreshHearts(); refreshCount(); renderList(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.BooksyWishlist = { has: has, count: count, toggle: toggle, remove: remove, refresh: function () { refreshHearts(); refreshCount(); } };
})();
